module.exports = __webpack_public_path__ + "img/er.774627b2.svg";